import * as React from "react";
import { PaymentInstructionLayout } from "../../../../../../../../component/modules/PaymentMethodsList/component/PaymentInstructionLayout.js";
const BancontactMobile = () => {
  return /* @__PURE__ */ React.createElement(PaymentInstructionLayout, { info: "checkout.payment.method.bancontact_mobile.info" });
};
export {
  BancontactMobile
};
//# sourceMappingURL=BancontactMobile.js.map
